<span class="text-xs italic font-hairline ">{{ publicationDate | date :'dd-MM-yyyy' }}</span>